import { Question } from './question';

export class QuestionLibre extends Question {
  resultat: string;
  referenceAnswer: string;
}
